import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ConstantsService } from '../../services/constants.service';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reimburse-modal',
  templateUrl: './reimburse-modal.component.html',
  styleUrls: ['./reimburse-modal.component.scss']
})
export class ReimburseModalComponent implements OnInit {

  approval_Form!:FormGroup;
  @Input() transId;
  @Input() claimId;
  @Input() isReimburseType;
  @Input() isReimburseObj;
  @Input() isDetailsResObj;

  currentDate = new Date();
  msg:string ="";
  requestedAmount: string = null;
  approvedAmount: string = null;
  paymentReferenceNumber: string = null;
  approvedStatusData: any;
  approvedStatusDate: Date;
  //deleteRequest = {};
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  isReimbursNew: boolean = false;
  isReimbursAssigned: boolean = false;
  isReimbursInreview: boolean = false;
  isReimbursRejected: boolean = false;
  isReimbursApproved: boolean = false;
  isReimbursPaymentPending: boolean = false;
  isReimbursPaid: boolean = false;
  minDate: Date;
  maxDate: Date;
  constructor(
    private fb:FormBuilder,
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { 
    this.maxDate = new Date();
  }

  ngOnInit(): void {

    // this.approvedStatusData = this.isDetailsResObj[0]["statusList"].filter(x => x.statusCode == 5);
    // console.log(`approvedStatusData`,this.approvedStatusData)
    // if(this.approvedStatusData != undefined && this.approvedStatusData != null){
    //     this.minDate=this.approvedStatusData[0].createdDate
    //     const utcDate = new Date(this.approvedStatusData[0].createdDate);
    //     this.minDate=utcDate
    // }
    this.isReimburseObj.statusList.filter((item: any) => {
      if (item.statusCode >= 5) {
        const utcDate = new Date(this.isReimburseObj.statusList[3].createdDate);
        this.minDate = utcDate    
      }
    })

    this.approval_Form=this.fb.group({
      requestedAmount:['', Validators.compose([Validators.required,]),],
      approvedAmount:['', Validators.compose([Validators.required,]),],
      paymentReferenceNumber:['', Validators.compose([Validators.required,]),],
      Remark: ['', Validators.compose([Validators.required,]),],
      billAmount: ['', Validators.compose([Validators.required,]),],
      selectDate: new FormControl(new Date())
    })
    this.approval_Form.patchValue({
      requestedAmount:this.isReimburseObj.requestedAmount,
      approvedAmount:this.isReimburseObj.approvedAmount,
      billAmount: this.isReimburseObj.lineitemAmount,
    })
    console.log(`isReimburseType`,this.isReimburseType)
    console.log(`isDetailsResObj`,this.isDetailsResObj[0])
    if(this.isReimburseType == 1){
        this.isReimbursNew = true;
    }else if(this.isReimburseType == 2){
        this.isReimbursAssigned = true;
    }else if(this.isReimburseType == 3){
        this.isReimbursInreview = true;
    }else if(this.isReimburseType == 4){
        this.isReimbursRejected = true;
    }else if(this.isReimburseType == 5){
      let requestedAmount = this.isReimburseObj.requestedAmount;
        this.isReimbursApproved = true;
    }else if(this.isReimburseType == 6){
        this.isReimbursPaymentPending = true;
    }else if(this.isReimburseType == 7){
      let requestedAmount = this.isReimburseObj.requestedAmount;
      let approvedAmount = this.isReimburseObj.approvedAmount;
        this.isReimbursPaid = true;
    }
  }

  confirmReimburse() {
    let confirmRequest = {};
    confirmRequest["claimId"] = this.claimId;
    confirmRequest["claimStatus"] = this.isReimburseType;
    confirmRequest["userId"] = window.localStorage.getItem('actionById');
    confirmRequest["transactionId"] = this.transId;
    confirmRequest["billAmount"] = this.approval_Form.value.billAmount;
    confirmRequest["remarks"] = this.approval_Form.value.Remark;
    if(this.isReimburseType == 5){
      confirmRequest["requestedAmount"] = String(this.isReimburseObj.requestedAmount);
      confirmRequest["approvedAmount"] = this.approval_Form.value.approvedAmount;
    }else if(this.isReimburseType == 7){
      this.currentDate=this.approval_Form.get('selectDate').value
      // this.currentDate=new Date()
      let todatDate=this.currentDate.toISOString().split('T')[0];
      confirmRequest["requestedAmount"] = String(this.isReimburseObj.requestedAmount);
      confirmRequest["approvedAmount"] = String(this.isReimburseObj.approvedAmount);
      confirmRequest["paymentReferenceNumber"] = this.approval_Form.value.paymentReferenceNumber;
      confirmRequest["paymentTransactionDate"] = todatDate;
    }else if (this.isReimburseType == 4) {
      confirmRequest["remarks"] = this.approval_Form.value.Remark;
    }

    console.log(`confirmRequest`,confirmRequest)
    this.omsServiceService.updateReimburseStatus(confirmRequest).subscribe(
      (res:any)=>{
console.log(`updateReimburseStatus`,res)
        if(res.status == 1)
        {
         this.isSuccessMsg =true;
         this.toastr.success(res.message);
         this.modal.close(); 
        }else{
          //alert(res["message"]);
          this.isFailureMsg =true;
          // this.msg =res["message"];
          this.toastr.error(res.message);
        }
      //  this.modal.close();
        this.SpinnerService.hide();
      })
  }

  modelClose()
  {
    this.modal.close();    
  }

}
